<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="note">
<p class="ct"><a class="xref" href="#/pppbookdeal0005#toc">Note</a></p>
<p class="pf">While I love South Florida just as it really and truly is, this is a work of fiction, and I have taken occasional liberties with the landscape and place-names involved. May they please the innocent and guilty alike.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-bookdeal0009.vue?573aafb2